export default {
  SET_LIST(state, items) {
    state.list = items;
  },
}
